module.exports = __webpack_public_path__ + "static/media/bitcoin-logo.41af9469.svg";